export default function preloaderGame6 (scene) {

    scene.load.image(`tilesgame6`, `/tiles/game6.png`);
    scene.load.image(`tilesgame6_complete`, `/tiles/game-6-complete.png`);

	scene.load.audio("piriSong", ["/audio/songs/6-piri.mp3"]);
	
	scene.load.spritesheet(`jiu-game6`, 
		`/img/game6/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`jiu2-game6`, 
		`/img/game6/jiu-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game6`, 
		`/img/game6/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`sua2-game6`, 
		`/img/game6/sua-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game6`, 
		`/img/game6/siyeon.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`siyeon2-game6`, 
		`/img/game6/siyeon-2.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game6`, 
		`/img/game6/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong2-game6`, 
		`/img/game6/handong-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game6`, 
		`/img/game6/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon2-game6`, 
		`/img/game6/yoohyeon-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game6`, 
		`/img/game6/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`dami2-game6`, 
		`/img/game6/dami-2.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game6`,
		`/img/game6/gahyeon.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon2-game6`,
		`/img/game6/gahyeon-2.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`humo-game6`, 
	`/img/generalSprites/humo-infinite.png`,
		{ frameWidth: 41, frameHeight: 42}
	);

	scene.load.tilemapTiledJSON(`game6`, `/tiles/game6.tmj`);

}